export default "__VITE_ASSET__W78ofC6l__"